import { NotificationService } from './../../_services/notification.service';
import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../_services/global.service';
import { PaginationInfo } from '../../_models/pagination-info';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription();
  notifications: any[] = [];
  unreadNotifications: any[] = [];
  paginationInfo: PaginationInfo;
  isLoading: boolean = false;
  constructor(
    private _global: GlobalService,
    private router: Router,
    private _notification: NotificationService
  ) {}
  ngOnInit() {
    this.getAllNotifications();
  }
  getAllNotifications() {
    this.isLoading = true;

    this.sub.add(
      this._notification
        .getAllNotifications()
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe({
          next: (res) => {
            this.notifications = res['responseResult'].notifications;
            this.paginationInfo = res['responseResult'].paginationInfo;
            this.unreadNotifications = this.notifications.filter(
              (n) => !n.read
            );
          },
        })
    );
  }

  navigatePage(page) {
    this._global.showSpinner();
    this._notification.getAllNotifications().subscribe({
      next: (res) => {
        this._global.hideSpinner();
        this.notifications = res['responseResult'].notifications;
        this.paginationInfo = res['responseResult'].paginationInfo;
      },
    });
  }

  view(notification) {
    // this._notification.readNotification(notification.).subscribe({
    //   next: (res) => {
    //     this._global.hideSpinner();
    //     this.notifications = res['responseResult'].notifications;
    //     this.paginationInfo = res['responseResult'].paginationInfo;
    //   },
    // });

    if (notification?.url) {
      const path = new URL(notification?.url).pathname.slice(1);
      this.router.navigate([path]);
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
